import {MOVE_DOWN, MOVE_UP} from "../components/clues/ClueNavButton";
import { db } from '../firebase';
// This import loads the firebase namespace along with all its type information.
import firebase from 'firebase/app';
// These imports load individual services into the firebase namespace.
import 'firebase/firestore';

import * as types from '../constants/ActionTypes'
import { store } from '../index';
import { isBoolean } from "lodash/lang";
import * as _ from "lodash";

import {AUTHOR_ID, AUTHOR_NAME, EVENT_DATE, PICTURE, PUBLIC} from "../constants/Game";
import * as admin from "firebase";
import { estimatedHuntDistance } from "../helper_functions";
import { deleteFileInFbStorage } from "../components/image/PhotoUpload";

function firestoreErrorToAlert(msg, error) {
    console.error(msg, error);
    alert(msg + ": " + error.message)
}

export function updateUserName(userId, name, callback) {

   db.updateUserName(userId, name)
        .then(callback)
        .catch(function(error) {
            firestoreErrorToAlert("Error writing new username", error);
        });

    return {
        type: types.UPDATE_USERNAME,
        payload: { name: name, id: userId }
    };
}

export function fetchUserGameStates(userId) {

   db.getGameStates(userId)
      .then(stateDocs => {
         // the states we're propogating is an array of gameStates, with gameId and userId added to each record.
         let states = [];
         stateDocs.docs.forEach(docRef => {
            let state = docRef.data();
            state.gameId = docRef.id;
            state.userId = userId;
            states.push(state);
         });
         store.dispatch({
            type: types.FETCH_GAME_STATES,
            payload: states
         });
      })
      .catch(function (error) {
         firestoreErrorToAlert("Error getting your game history", error);
         store.dispatch({
            type: types.FETCH_GAME_STATES,
            payload: []
         });
      });
}

export function createGame(values, authorName, isPublic, callback) {

   const gameCollection = isPublic ? db.PUBLIC_GAMES : db.PRIVATE_GAMES;

    db.createGame(gameCollection, values)
        .then( (docRef) => {
            store.dispatch({
                type: types.CREATE_GAME,
                payload: {
                    id: docRef.id,
                    ...values,
                    authorName: authorName,
                    isPublic: isPublic
                }
            });
            callback(docRef)
        })
        .catch(function(error) {
            firestoreErrorToAlert("Error writing new game document", error);
        });

    return {
        type: types.CREATE_GAME,
        payload: null
    };
}

// update the specified game with the data in the values object
export function updateGame(gameId, isPublic, values, callback) {

    // clean out undefined values.  (empty string ok).  But leave eventDate: null and hunt_picture in there.
    const omitFromClean = { [EVENT_DATE]: "", [PICTURE]: ""};
    clean(values, omitFromClean);

    if (! isBoolean(isPublic)) {
        alert("Programming Error.  'isPublic' is missing from game state in update game. "
            + "Game will not be updated since we don't know which collection to write to.");

        return {
            type: types.UPDATE_GAME,
            payload: null
        };
    }

    const gameCollection = isPublic ? db.PUBLIC_GAMES : db.PRIVATE_GAMES;
    values.lastModified = firebase.firestore.Timestamp.now();
    values.isPublic = isPublic;

   db.updateGame(gameCollection, gameId, values)
        .then( () => {
            store.dispatch({
                type: types.UPDATE_GAME,
                payload: { id: gameId, ...values }
            });
            callback()
        })
        .catch(function(error) {
            firestoreErrorToAlert("Error updating game on server.", error);
        });

    return {
        type: types.UPDATE_GAME,
        payload: null
    };
}

export function fetchAllPublicGames() {

   db.getAllPublicGames()
      .then(gameDocs => {
         let games = [];
         gameDocs.docs.forEach( docRef => {
            let game = docRef.data();
            game.id = docRef.id;
            games.push(game);
         });
         fetchAuthors(games);
         store.dispatch({
            type: types.FETCH_GAMES,
            payload: games
         });
      });
}

const processGameDocs = (gameDocs) => {
   let games = [];
   gameDocs.docs.forEach(docRef => {
      let game = docRef.data();
      game.id = docRef.id;
      games.push(game);
   });
   fetchAuthors(games);
   store.dispatch({
      type: types.FETCH_GAMES,
      payload: games
   });
}

export function fetch40DaysOfGames() {
   const fortyDays = 1000*3600*24*40;
   const fortyDaysAgo = new Date(Date.now() - fortyDays);

   db.getGamesCreatedGamesInPeriod(
      db.PUBLIC_GAMES,
      fortyDaysAgo
   )
      .then(processGameDocs);

   db.getGamesCreatedGamesInPeriod(
      db.PRIVATE_GAMES,
      fortyDaysAgo
   )
      .then(processGameDocs);
}

// export function fetchGamesCreatedByMonth(year, month) {
export function fetchGamesCreatedByMonth(moment) {
   const startDate = moment.toDate();

   moment.add(1, 'months')
   const endDate = moment.toDate();

   db.getGamesCreatedGamesInPeriod(
      db.PUBLIC_GAMES,
      startDate,
      endDate
   )
      .then(processGameDocs);

   db.getGamesCreatedGamesInPeriod(
      db.PRIVATE_GAMES,
      startDate,
      endDate
   )
      .then(processGameDocs);
}

export function fetchSampleGames() {

    db.getSampleGames()
       .then(processGameDocs);
}

export function fetchGamesByUser(user) {

    if (!user || !user.id) {
        console.warning("user null -- not fetching games");
        return;
    }

    // what to do with the game docs depending on whether we're getting public or private ones.
    const thenFunction = (isPublic) =>
        (gameDocs) => {
            let games = [];
            gameDocs.docs.forEach( docRef => {
                let game = docRef.data();
                game.id = docRef.id;
                game.authorName = !!user.name ? user.name : "Unknown";
                game.isPublic = isPublic;
                games.push(game);
            });
            store.dispatch({
                type: types.FETCH_GAMES,
                payload: games
            });
        };

    // get the games.
    db.getPublicGamesByUserId(user.id)
        .then(thenFunction(true));
    db.getPrivateGamesByUserId(user.id)
        .then(thenFunction(false));

    // default displatch
    return {
        type: types.FETCH_GAMES,
        payload: null
    }
}

/** Fetches one game when selected.  Tries to find game in both public and private collections.
 *   When found, this adds the game to our state games collection and changes our current selected game to this one.
 */

export function fetchGame(gameId) {

   db.getPublicGame(gameId)
        .then(dispatchFetchGameFunction(true));

    db.getPrivateGame(gameId)
        .then(dispatchFetchGameFunction(false));

    return {
        type: types.FETCH_GAME,
        payload: null
    }
}

function dispatchFetchGameFunction(isPublic) {

   return (gameDoc) => {
        if (!gameDoc || !gameDoc.data()) {
            return;
        }
        const game = gameDoc.data();
        game.id = gameDoc.id;
        game.isPublic = isPublic;
        fetchAuthors([game]);
        store.dispatch({
            type: types.FETCH_GAME,
            payload: game
        });
    };
}

export function fetchPublicGame(gameId) {
    db.getPublicGame(gameId)
        .then(dispatchFetchGameFunction(true));
}

export function fetchPrivateGame(gameId) {
    db.getPrivateGame(gameId)
        .then(dispatchFetchGameFunction(false));
}

export function fetchMultiplePublicGames(gameIds) {
    // for each
    for (let i=0; i<gameIds.length; i++) {
        fetchPublicGame(gameIds[i])
    }
}

export function fetchMultiplePrivateGames(gameIds) {
    // for each
    for (let i=0; i<gameIds.length; i++) {
        fetchPrivateGame(gameIds[i])
    }
}

export function fetchAuthors(games) {

    games.forEach( game => {
        fetchAndAttachAuthorToGame(game);
    });

    return {
        type:  types.UPDATE_GAME,
        payload: null
    }
}

export function fetchClueIcons() {

    db.getRemoteStorage()
       .then(doc => {
           const data = doc.data();
           const clueIcons = data.clueIcons;

           store.dispatch({type: types.FETCH_CLUE_ICONS, payload: clueIcons});
       })
       .catch(function(error) {
           firestoreErrorToAlert("Error deleting game", error);
       });
}

export function fetchStatsForGame(game) {

   // also retrieve reviews and reports
    fetchReviewsForGame(game);
    fetchReportsForGame(game);

    const gameCollection = game[PUBLIC] ? db.PUBLIC_GAMES : db.PRIVATE_GAMES;

    db.getLeaderboard(gameCollection, game.id)
       .then(leaderboardDocs => {
         let leaderboard = []
         leaderboardDocs.docs.forEach(docRef => {
            let entry = docRef.data();
            entry.userId = docRef.id;
            entry.gameId = game.id;
            leaderboard.push(entry)
         });
             store.dispatch({
                type: types.FETCH_LEADERBOARD_FOR_GAME,
                payload: { leaderboard: leaderboard , gameId: game.id }
             })
          }
       )
       .catch(function(error) {
          firestoreErrorToAlert("Error fetching hunt activity leaderboard:", error);
          store.dispatch({
             type: types.FETCH_LEADERBOARD_FOR_GAME,
             payload: {leaderboard: [], gameId: game.id}
          })
       })


          db.getStats(gameCollection, game.id)
       .then(statsDocs => {

          let stats = [];
           statsDocs.docs.forEach(docRef => {
               let oneStats = docRef.data();
               oneStats.userId = docRef.id;
               oneStats.gameId = game.id;
               // We're likely only going to need user name for stats with 1 clue, since otherwise
               // they'll be on the leaderboard
               if (oneStats.farthestClue < 2) {
                  fetchAndAttachUserToStat(oneStats);
               }
               stats.push(oneStats);
           });

           store.dispatch({
               type: types.FETCH_STATS_FOR_GAME,
               payload: { stats: stats, gameId: game.id }
           })
       })
      .catch(function(error) {
         firestoreErrorToAlert("Error fetching hunt activity:", error);
         store.dispatch({
            type: types.FETCH_STATS_FOR_GAME,
            payload: { stats: [], gameId: game.id }
         })
      });
}

export function fetchRecentStats() {

   const now = new Date();
   const millis = now.getTime();
   const twoWeeksBackMillis = millis - 2*7*24*3600*1000;
   const twoWeeksAgoTS = admin.firestore.Timestamp.fromDate(new Date(twoWeeksBackMillis));

   db.getAllRecentStats(twoWeeksAgoTS)

      .then(statsDocs => {
         let stats = [];
         statsDocs.docs.forEach(docRef => {

            let oneStats = docRef.data();

            oneStats.userId = docRef.id;
            oneStats.gameId = docRef.ref.parent.parent.id;   // doc parent is "gameStats" collections.  That parent is a game doc.
            // oneStats.gameId = game.id;
            fetchAndAttachUserToStat(oneStats);
            stats.push(oneStats);
         });

         store.dispatch({
            type: types.FETCH_STATS_RECENT,
            payload: stats
         })
      })
      .catch(function(error) {
         firestoreErrorToAlert("Error getting gameStats", error);
      });
}

export function fetchReviewsForGame(game) {
   const gameCollection = game[PUBLIC] ? db.PUBLIC_GAMES : db.PRIVATE_GAMES;
    db.getReviews(gameCollection, game.id)
       .then(reviewDocs => {

           let reviews = {};
           reviewDocs.docs.forEach(docRef => {
               let review = docRef.data();
               review.userId = docRef.id;
               review.gameId = game.id;
               reviews[docRef.id] = review;
           });

           store.dispatch({
               type: types.FETCH_REVIEWS,
               payload: { reviews: reviews, gameId: game.id }
           })
       })
}

export function fetchReportsForGame(game) {
   const gameCollection = game[PUBLIC] ? db.PUBLIC_GAMES : db.PRIVATE_GAMES;
   db.getReports(gameCollection, game.id)
      .then(reportsDocs => {

         let reports = [];
         reportsDocs.docs.forEach(docRef => {
            let report = docRef.data();
            report.userId = docRef.id;
            report.gameId = game.id;
            reports[docRef.id] = report;
         });

         store.dispatch({
            type: types.FETCH_REPORTS,
            payload: {reports: reports, gameId: game.id}
         })
      })
}

export function fetchAndAttachAuthorToGame(game) {
    const { id } = game;
    const userId = game[AUTHOR_ID];

    if (userId != null) {
        db.getUser(userId)
            .then(userDoc => {
                const userData = userDoc.data();
                if (!userData) {
                    console.warn("no user record found for userId: " + userId);
                    return;
                }
                if (userData.name) {
                    const gameIdUserData = {id: id, [AUTHOR_ID]: userId, authorName: userData.name};
                    store.dispatch({type: types.UPDATE_GAME, payload: gameIdUserData});
                }
            });
    } else {
        console.warn("game with no authorId: " + game.title);
    }

    return {
        type:  types.UPDATE_GAME,
        payload: null
    }
}

export function fetchAndAttachUserToStat(stat) {
    const userId = stat.userId;
    const gameId = stat.gameId;

    if (userId != null && gameId != null) {
        db.getUser(userId)
           .then(userDoc => {
               const userData = userDoc.data();
               if (!userData) {
                   return;
               }
               if (userData.name) {
                   const gameIdUserData = {gameId: gameId, userId: userId, username: userData.name, email: userData.email };
                   store.dispatch({type: types.UPDATE_STAT, payload: gameIdUserData});
               }
           });
    } else {
        console.warn("stat with missing gameId or userId: ", stat);
    }

    return {
        type:  types.UPDATE_STAT,
        payload: null
    }
}

// Converts private game to public (giving it new ID) or public game to private.
// Game passed in should be fully formed, including all the things for a game.
export function convertGame(game, callback, error) {

   const isPublic = game[PUBLIC];

   const newGame = _.cloneDeep(game);
   // reverse of first game.
   newGame[PUBLIC] = !isPublic;

   const deleteOldGameCallback = (docRef) => {

      const loadNewPageCallback = () => {
         callback(docRef)
      };

      deleteGame(game.id, isPublic, loadNewPageCallback)
   };
   newGame.deepLink = null;

   createGame(newGame, newGame[AUTHOR_NAME], newGame[PUBLIC], deleteOldGameCallback)
}

export function deleteGame(gameId, isPublic, callback) {

    const gameCollection = isPublic ? db.PUBLIC_GAMES : db.PRIVATE_GAMES;

    db.deleteGame(gameCollection, gameId)
        .then( () => {
            store.dispatch({type: types.DELETE_GAME, payload: gameId});
            callback();
        })
        .catch(function(error) {
            firestoreErrorToAlert("Error deleting game", error);
        });

    return {
        type: types.DELETE_GAME,
        payload: null
    }
}

export function selectGame(game) {
    return {
        type: types.GAME_SELECTED,
        payload: game.id
    }
}

export function createClue(game, values, callback) {

   const existingClues = game.clues ? game.clues : [];

   const clueArray = existingClues.slice();
   clueArray.push(values);

    return updateClues(game, clueArray, callback);
}

// Replace an existing clue with all new values.    // todo: this seems fraught.  Please do away with this.  But how?
         // We could switch to update AND be sure to include all the values we want to change, even nulled out ones.   (hard?_
export function editClue(game, values, selectedClue, callback) {

   const existingClues = game.clues;

    const index = existingClues.indexOf(selectedClue);
    if (index !== -1) {
        existingClues[index] = values;
    }
    const clueArray = existingClues.slice();

    return updateClues(game, clueArray, callback);
}


// Update those attributes of an existing clue that are present in values.
export function updateClue(game, clue, values, callback) {

   const existingClues = game.clues;
   const index = existingClues.indexOf(clue);
   if (index !== -1) {
      Object.assign(existingClues[index], values);
   }
   const clueArray = existingClues.slice();
   return updateClues(game, clueArray, callback);
}

export function moveClue(game, indexToMove, direction, callback) {
   const clueArray = game.clues;

    // First, move the clues around, using the existing array and object references.
    const clueToMove = clueArray[indexToMove];

    let targetClue;
    let targetIndex = indexToMove;

    if (direction === MOVE_UP) {
        targetIndex--;
    }
    else if (direction === MOVE_DOWN) {
        targetIndex++;
    }

    targetClue = clueArray[targetIndex];

    clueArray[targetIndex] = clueToMove;
    clueArray[indexToMove] = targetClue;

    return updateClues(game, clueArray, callback);
}

export function deleteClue(game, index, callback) {

   const existingClues = game.clues;
   const clue = existingClues[index];

   existingClues.splice(index, 1);
   const clueArray = existingClues.slice();

   const innerCallback = () => {
      deleteClueImagesNoCallback(clue)
      callback();
   }

   return updateClues(game, clueArray, innerCallback);
}

export function deleteClueImagesNoCallback(clue) {
   const pictureClue = clue.clue_picture;
   const pictureThumb = clue.clue_thumb;
   const answerPhoto = clue.answer_photo;
   const answerThumb = clue.answer_thumb;
   if (!!pictureClue) {
      deleteFileInFbStorage(pictureClue);
      deleteFileInFbStorage(pictureThumb);
   }
   if (!!answerPhoto) {
      deleteFileInFbStorage(answerPhoto);
      deleteFileInFbStorage(answerThumb);
   }
}

// NOTE:  this function returns immediately with the updated values.  'callback' is executed
// when the promise completes, but if you want to refresh to the server values you'll have to
// then call fetchClues.
function updateClues(game, clueDataArray, callback) {

   const { id, isPublic, bounding_box } = game;

   // Next, repost the clues.
   const durationText = estimatedHuntDistance(bounding_box, clueDataArray);

    const values = {
       clues: clueDataArray,
       duration: durationText,
       lastModified: firebase.firestore.Timestamp.now()
    };

    const gameCollection = isPublic ? db.PUBLIC_GAMES : db.PRIVATE_GAMES;

    db.updateClues(gameCollection, id, values)
            .then(callback)
            .catch(function(error) {
                firestoreErrorToAlert("Error updating clues", error);
            });

    return {
        type: types.UPDATE_CLUES,
        payload: { gameId: id, clues: values.clues, lastModified: values.lastModified }
    };
}

/** Set the current clue being edited.  Can set to null if desired.*/
export function selectClue(clue) {

    return {
        type: types.CLUE_SELECTED,
        payload: clue
    }
}

function clean(obj, omitFromClean) {
    for (var propName in obj) {

        if (!!omitFromClean && propName in omitFromClean) continue;

        if (obj[propName] === null || obj[propName] === undefined) {
            delete obj[propName];
        }
    }
}



// WEBPACK FOOTER //
// ./src/actions/index.js